// const { default: axios } = require("axios");

const BLANK_PLAYER = { id: 0, name: '', position: '', age: '', club: { id: 0, name: '' }, eligible: 'yes' };
// const GK_SKILL_LABEL = getLang('goalkeeping');

// helper object for setting up NoUI sliders
let sliders = {
    inputs: [],
    init: function(id, options) {
        // create the slider
        this.inputs[id] = noUiSlider.create(
            document.querySelector('#slider__' + id),
            options
        );
        //set up handlers
        if( typeof( options.start ) == 'number' ) {
            // update label (using getElementById.innerHTML for performance)
            this.inputs[id].on('update', function(value) {
                document.getElementById('slider-value__' + id).innerHTML = +value;
            });
            // update Store (debounced for performance)
            this.inputs[id].on('update', _.debounce( function(value) {
                Spruce.store('inputs').set(id, +value);
            }, 100));
        } else {
            // update labels (using getElementById.innerHTML for performance)
            this.inputs[id].on('update', function (values, handle) {
                let v = +values[handle];
                let suffix = '';

                // special case for value
                if( id === 'value' ) {
                    // add a suffix of K or M
                    suffix = +values[handle] < 1  ? 'K' : 'M';

                    // multiply by 1000 if < 1 million as we'll be displaying 1000s
                    v = v < 1 ? v * 1000 : v;

                    // if it's the last handle and 100m then add a + to signify this will also match anything over this
                    if( handle === 1 && +values[handle] === 100 ) {
                        suffix+= '+';
                    }
                }

                document.getElementById('slider-value-' + (handle === 0 ? 'min' : 'max') + '__' + id).innerHTML = v + suffix;
            });
            // update Store (debounced for performance)
            this.inputs[id].on('update', _.debounce( function (values, handle) {
                let current = Spruce.store('inputs').current[id];
                if (handle === 0) {
                    Spruce.store('inputs').set( id, {
                        min: +values[handle],
                        max: +current.max
                    });
                } else {
                    Spruce.store('inputs').set(id, {
                        min: +current.min,
                        max: +values[handle]
                    });
                }
            }, 100));
        }
    },
    set: function(id, value) {
        this.inputs[id].set(value);
    },
    updateOptions: function(id, newOptions) {
        this.inputs[id].updateOptions(newOptions, false);
    }
};

// The find player Alpine object and other associated constants
window.appFindPlayers = () => {
    return {

        player: {}, // player details of whom to find a match

        playerMatches: {
            active: false, //status of the matches popout
            results: [], //the player match query results
            activeMenus: [], // keep track of rollover menus
            revealed: false, // for anonymous mode
        },

        search: {
            active: false, //status of the search popout
            query: '', //text query for the search popout
            results: [] //player name search results
        },
        initialWeightings: {}, // old scores that are passed back to the API
        filters: {}, // the search player name filters
        leagues: [], // a list of leagues to filter by
        clubs: [], // a list of clubs to filter by
        searchResultsLoading: false,  // track whether the search results are loading or not
        clubsLoaded: false, //track if the list of clubs has loaded or not

        searches: {total: 0, spent: 0, remaining: 0},

        router: function(state) {
            /*
             * Do nothing is the state is not defined
             */
            if( typeof(state) === 'undefined') {
                return;
            }

            /*
             * if we're at the root then no need to do anything
             */
            if( state.root && state.url == '' ) {
                return;
            }

            /*
             * if the URL is nothing then close popups if one was set
             */
            if( state.url === '' ){
                popupIsActive = false;
                popup.close(true);
                this.closePlayerMatches(true)
                return;
            }

            /*
             * player profile
             */
            let playerProfileUrl = /^player-profile\/([a-z-]+)\/(\d+)$/;
            let playerProfileMatches = state.url.match(playerProfileUrl);
            if( playerProfileMatches && playerProfileMatches.length === 3 ) {
                // if this wasn't a push (i.e. user click) then load the popup
                if( ! state.pushed ) {
                    playerProfile.load({ id: playerProfileMatches[2], name: playerProfileMatches[1] }, true)
                }
                return;
            }

            /*
             * results popout, rerun search if already set
             */

            let resultsUrl = /^results\/([a-z-]+)\/(\d+)\/(\d+)\/(\d)\/(\d)\/([\d,]+)(\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/([0-1])\/([0-1])\/([0-1])\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/(\d+)\/([\d.]+)\/([\d.]+)\/([\d.]+)\/([\d.]+))?$/;
            let resultsMatches = state.url.match(resultsUrl);
            if( resultsMatches && ( resultsMatches.length === 7 || resultsMatches.length === 30 ) ) {

                // if we came from a popup then do nothing else
                if( popupIsActive === true ) {
                    popupIsActive = false;
                    popup.close(true);
                    return;
                }

                // if we have just carried out a search then do nothing else
                if( state.pushed ) {
                    return;
                }

                // loading screen on as this will take a moment
                $c('appMain').loading = true;

                // Update the labels in the select box components for skill and style (the others are set via ajax once they load)
                $c('selectInputsSkillId').label = $c('selectInputsSkillId').items[
                    $c('selectInputsSkillId').items.findIndex(i => i.value == resultsMatches[4])
                ].label;
                $c('selectInputsStyleId').label = $c('selectInputsStyleId').items[
                    $c('selectInputsStyleId').items.findIndex(i => i.value == resultsMatches[5])
                ].label;

                //set the season, skill, style and league
                let inputs = {
                    seasonId: resultsMatches[3], // label will be set when seasons are loaded via ajax
                    skillId: resultsMatches[4],
                    styleId: resultsMatches[5],
                    leagueIds: resultsMatches[6].includes(',') ? resultsMatches[6].split(',') : [resultsMatches[6]] // label will be set when leagues are loaded via ajax
                }
                //set additional pro items
                if( (pro() || elite()) && resultsMatches.length == 30 ) {
                    inputs = {
                        ...inputs,
                        passing: +resultsMatches[8],
                        creating: +resultsMatches[9],
                        shooting: +resultsMatches[10],
                        defensive: +resultsMatches[11],
                        gbeEligible: parseInt(resultsMatches[16]), // must be 0 or 1, not a string
                        gbePotential: parseInt(resultsMatches[17]), // must be 0 or 1, not a string
                        gbeIneligible: parseInt(resultsMatches[18]), // must be 0 or 1, not a string
                        nationId: +resultsMatches[19],
                        age: { min: +resultsMatches[20], max: +resultsMatches[21] },
                        height: { min: +resultsMatches[22], max: +resultsMatches[23] },
                        minutesPlayed: { min: +resultsMatches[24], max: +resultsMatches[25] },
                        value: { min: +resultsMatches[26], max: +resultsMatches[27] },
                        contractLength: { min: +resultsMatches[28], max: +resultsMatches[29] },
                        internationalApps: parseInt(resultsMatches[30]), // must be 0 or 1, not a string
                    }
                    this.initialWeightings = {
                        passing: +resultsMatches[12],
                        creating: +resultsMatches[13],
                        shooting: +resultsMatches[14],
                        defensive: +resultsMatches[15],
                    }
                }
                this.$store.inputs.current = {...inputs};

                // get the player's details via ajax and set via setPlayer
                axios.get('/api/player/' + resultsMatches[2])
                    .then( response => {
                        let player = {...response.data, eligible: 'yes'};
                        this.setPlayer(player, true);

                         // load in the matches for this player
                        this.loadPlayerMatches();
                    })
                    .catch( ajaxFail )
            }
        },

        init: function() {
            // get remaining searches for standard mode
            if( standard() ) {
                this.updateRemainingSearches();
            }

            // default sort state
            this.$store.sortBy = 'percentageMatch';

            //initialise the player
            this.player = Object.create( BLANK_PLAYER );

            // initialise the filters - this will be fully reset via openSearch
            this.filters = {
                league: { active: false, id: 0, label: getLang('all_leagues') },
                club: { active: false, id: 0, label: getLang('all_clubs') },
            };

            // if the club or league changes then update the player search results
            this.$watch( "filters.league.id", () => this.getPlayers());
            this.$watch( "filters.club.id", () => this.getPlayers());

            // initialise global filters
            Spruce.store('inputs', {
                current: {},
                defaults: {
                    seasonId: 0,
                    skillId: 0,
                    styleId: 0,
                    leagueIds: [0],
                    passing: 50,
                    creating: 50,
                    shooting: 50,
                    defensive: 50,
                    gbeEligible: 1,
                    gbePotential: 1,
                    gbeIneligible: 1,
                    nationId: 0,
                    age: { min: 15, max: 35 },
                    height: { min: 150, max: 210 },
                    minutesPlayed: { min: 50, max: 5000 },
                    value: { min: 0, max: 100 },
                    contractLength: { min: 0, max: 5 },
                    internationalApps: 0,
                },
                set(key, value) {
                    this.current[key] = value;
                },
                reset() {
                    this.current = {...this.defaults};
                }
            });
            this.$store.inputs.reset();

            // load in default player weightings when the season changes
            if( pro() || elite() ) {
                this.$nextTick( () => {
                    Spruce.watch('inputs.current.seasonId', () => this.setPlayerWeightings());
                });
            }

            // basic routing for this page
            Spruce.watch('history', state => this.router(state));

            // pro extra sliders
            if( pro() || elite() ) {
                this.$nextTick( () => {
                    sliders.init('passing', {
                        start: +this.$store.inputs.current.passing,
                        step: 1,
                        connect: [true, false],
                        range: { min: 0, max: 100 }
                    });
                    sliders.init('creating', {
                        start: +this.$store.inputs.current.creating,
                        step: 1,
                        connect: [true, false],
                        range: { min: 0, max: 100 }
                    });
                    sliders.init('shooting', {
                        start: +this.$store.inputs.current.shooting,
                        step: 1,
                        connect: [true, false],
                        range: { min: 0, max: 100 }
                    });
                    sliders.init('defensive', {
                        start: +this.$store.inputs.current.defensive,
                        step: 1,
                        connect: [true, false],
                        range: { min: 0, max: 100 }
                    });
                    sliders.init('age', {
                        start: [+this.$store.inputs.current.age.min, +this.$store.inputs.current.age.max],
                        connect: true,
                        step: 2,
                        margin: 2,
                        range: { min: 15, max: 35 }
                    });
                    sliders.init('height', {
                        start: [+this.$store.inputs.current.height.min, +this.$store.inputs.current.height.max],
                        connect: true,
                        step: 10,
                        margin: 10,
                        range: { min: 150, max: 210 }
                    });
                    sliders.init('minutesPlayed', {
                        start: [+this.$store.inputs.current.minutesPlayed.min, +this.$store.inputs.current.minutesPlayed.max],
                        connect: true,
                        step: 50,
                        margin: 50,
                        range: { min: 50, max: 5000 }
                    });
                    sliders.init('value', {
                        start: [+this.$store.inputs.current.value.min, +this.$store.inputs.current.value.max],
                        // start: [0, 100],
                        connect: true,
                        step: 1,
                        margin: 1,
                        range: {
                            'min': [0,   0.025000],
                            '5%': [0.1, 0.050000],
                            '25%': [1,   0.100000],
                            '80%': [10,  1.000000],
                            'max': [100.000000]
                        },
                        format: wNumb({
                            decimals: 3
                        })
                    });
                    sliders.init('contractLength', {
                        start: [+this.$store.inputs.current.contractLength.min, +this.$store.inputs.current.contractLength.max],
                        connect: true,
                        step: 0.5,
                        margin: 0.5,
                        range: { min: 0, max: 5 }
                    });
                });
            }
        },

        /*
         * In standard mode, there is a limit to the number of searches per day
         * this gets an update from the API of these for this user
         */
        updateRemainingSearches: function() {
            axios.get('/api/searches/').then( response => {
                this.searches.total = response.data.searches_total;
                this.searches.spent = response.data.searches_spent;
                this.searches.remaining = this.searches.total - this.searches.spent;
                if(this.searches.remaining < 0) this.searches.remaining = 0;
            });
        },

        /*
         * Not needed for find-players, but used for the find players popout which is used
         * with both find players and comparison
         */
        hasGoalkeeper: function() {
            return false;
        },

        /*
         * When a player is added, a popout appears with the option to search for
         * players by name, also a league and club can be optionally set which will
         * filter these results. This function opens the popout and preloads the
         * list of leagues
         */
        openSearch: function() {
            // Show the loading notice and cover the add player panel
            this.$store.loading = true;
            this.$store.cover = true;

            // Get the list of leagues
            axios.get('/api/leagues/')
                .then( response => {
                    // Save the player results
                    this.leagues = Object.create( response.data );

                    // add in All leagues
                    //this.leagues.unshift({ id: 0, name: getLang('all_leagues'), countryId: 0, countryName: '' });

                    // Hide the loading notice and open the search popout
                    this.$store.loading = false;
                    this.search.active = true;

                    // reset the search query (this doesn't always trigger from closeSearch)
                    this.search.results = [];

                    // Focus the query input
                    this.$nextTick( () => this.$refs.searchQuery.focus() );

                })
                .catch( response => {
                    modal(getLang('generic_error'));

                    // Hide the loading notice
                    this.$store.loading = false;
                })

            //stop document scrolling
            document.querySelector('html').classList.add('overflow-hidden');
        },

        /*
         * Close the player search popout and tidy up, including resetting the
         * search filters and the search query.
         *
         * This is triggered either by a click to the popout's close button,
         * or when a row is clicked.
         */
        closeSearch: function() {
            // Close the search popout and hide the add player panel cover
            this.search.active = false;
            this.$store.cover = false;

            // Re-enable document scrolling
            document.querySelector('html').classList.remove('overflow-hidden');

            // reset the search query
            this.search.query = '';

            // reset the search results
            this.search.results = [];

            // Reset the search filters
            this.filters.league.active = false;
            this.filters.league.id = 0;
            this.filters.league.label = getLang('all_leagues');
            this.filters.club.active = false;
            this.filters.club.id = 0;
            this.filters.club.label = getLang('all_clubs');
        },

        /*
         * This sets the league to filter players with.
         *
         * This is triggered by clicking a row on the list of leagues.
         */
        setFilterLeague: function(league) {
            // Set the league name and ID
            this.filters.league.id = league.id;
            this.filters.league.label = league.name;

            // Hide the list of leagues
            this.filters.league.active = false;

            // reset the club
            this.filters.club.active = false;
            this.filters.club.id = 0;
            this.filters.club.label = getLang('all_clubs');

            // Set a flag that the clubs haven't been loaded, this is used to determine
            // whether or not the clubs filter dropdown is disabled or not
            this.clubsLoaded = false;

            // Load the list of clubs for this league
            if( league.id != 0 ) {
                axios.get('/api/clubs/' + league.id)
                .then( response => {
                    // Save the results
                    this.clubs = Object.create( response.data );

                    // Update the flag
                    this.clubsLoaded = true;

                    // show the clubs list
                    this.filters.club.active = true;
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
            }
        },

        /*
         * This sets the club to filter players with.
         *
         * This is triggered by clicking a row on the list of clubs.
         */
        setFilterClub: function(club) {
            // Set the club name and ID
            this.filters.club.id = club.id;
            this.filters.club.label = club.name;

            // Hide the list of clubs
            this.filters.club.active = false;

        },

        /*
         * This fetches a list of players via AJAX for the player search popout,
         * it uses the player name (3 characters minimum) and optional filters
         * for the league and club.
         *
         * It is triggered by the search input field with an input handler.
         *
         * It is also called by watchers for filters.league.id and filters.club.id
         */
        getPlayers: function() {
             // Show the local loading notice just for the player name list
            this.searchResultsLoading = true;

             // Fetch the players that match the query and filters
            let params = {
                league_id: this.filters.league.id,
                club_id: this.filters.club.id,
            };
            if( pro() || elite() ) {
                params = {
                    ...params,
                    eligible: 'no'
                };
            }
            axios.get('/api/players/' + ( this.search.query.length < 3 ? '-1' : this.search.query ), {
                params
            })
                .then( response => {
                    // Save the player results
                    this.search.results = Object.create( response.data );

                    // Hide the local loading notice
                    this.searchResultsLoading = false;
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
        },

        /*
         * Sets the player to find matches for.
         *
         * This is triggered either when a row is clicked.
         */
        setPlayer: function(player, fromRouter) {
            if( ! fromRouter ) {
                // close the search
                this.closeSearch()

                // Show the loading notice and cover again as the seasons will need to load
                this.$store.loading = true;
                this.$store.cover = true;

                // Reset the global filters
                this.$store.inputs.reset();

                // Update the labels in the select box components
                $c('selectInputsSeasonId').label = $c('selectInputsSeasonId').initialLabel;
                $c('selectInputsSkillId').label = $c('selectInputsSkillId').initialLabel;
                $c('selectInputsStyleId').label = $c('selectInputsStyleId').initialLabel;
                $c('selectLeagueId').label = $c('selectLeagueId').initialLabel;
            }

            // Set the player's details
            this.player = {
                id: player.id,
                name: player.name,
                position: player.position,
                positionTranslated: player.positionTranslated,
                age: player.age,
                club: { id: player.club.id, name: player.club.name },
                eligible: player.eligible,
            };

            // hide the league filter
            $c('selectLeagueId').expanded = false;

            //reset the skills array
            skills[config.lang].forEach( skill => skill.value = skill.originalValue );

            // disable the non-Goalkeeping skills for outfield players, and the outfield skills for goalkeepers
            // let gkSkillIndex = skills[config.lang].findIndex(i => i.label == GK_SKILL_LABEL);
            let gkSkillIndex = 6; // just hardcode the index, it's not likely to change
            if( player.position == 'GK' ) {
                skills[config.lang].forEach((skill, index) => skill.value = index != gkSkillIndex ? 0 : skill.value ); //disable the outfield skills
                this.$store.inputs.current.skillId = skills[config.lang][gkSkillIndex].value; // select the goalkeeping skill
                $c('selectInputsSkillId').label = skills[config.lang][gkSkillIndex].label; // update the skills label
            } else {
                skills[config.lang][gkSkillIndex].value = 0; // disable the goalkeeping skill
            }

            if( pro() || elite() ) {
                // Update the minutes player slider minumum for players under 21
                if( player.age <= 21 ) {
                    sliders.updateOptions('minutesPlayed', { range: { min: 100, max: 5000 } });
                    sliders.set('minutesPlayed', 100);
                }

                // Update the GBE status checkboxes
                $c('checkboxGbeEligible').active = true;
                $c('checkboxGbePotential').active = true;
                $c('checkboxGbeIneligible').active = true;
                $c('checkboxInternationalApps').active = false;

            }

            // Load in the seasons for this player
            let endpoints = ['/api/seasons/' + this.player.id];

            // additional endpoint for pro
            if( pro() || elite() ) {
                endpoints = [...endpoints, '/api/nations'];
            }

            // make the calls and then process each promise when it's fullfilled...
            let promises = endpoints.map(
                endpoint => axios.get(endpoint)
            );

            // process each promise
            axios.all(promises)
                .then(
                    axios.spread((...responses) => {
                        // Update the season select box component's item list
                        $c('selectInputsSeasonId').items = Object.create( responses[0].data );

                        // if the season ID is already set, then set the label
                        if( this.$store.inputs.current.seasonId ) {
                            $c('selectInputsSeasonId').label =
                                $c('selectInputsSeasonId').items[
                                    $c('selectInputsSeasonId').items.findIndex(i => i.value == this.$store.inputs.current.seasonId)
                                ].label;
                        }

                        if( pro() || elite() ) {

                            let nations = Object.create( responses[1].data )

                            // add in All nations
                            nations.unshift({ value: 0, label: getLang('all_nations') });

                            // Update the nationality select box component's item list
                            $c('selectInputsNationId').items = nations;

                            // if the nation ID is already set, then set the label
                            if( this.$store.inputs.current.nationId ) {
                                $c('selectInputsNationId').label =
                                    $c('selectInputsNationId').items[
                                        $c('selectInputsNationId').items.findIndex(i => i.value == this.$store.inputs.current.nationId)
                                    ].label;
                            }
                        }

                        // Hide the loading notice and add player panel cover
                        this.$store.loading = false;
                        this.$store.cover = false;
                    })
                )
                .catch( errors => {
                    modal(getLang('generic_error'));

                    // Remove the current player, and hide the loading notice and cover
                    this.removePlayer();
                    this.$store.loading = false;
                    this.$store.cover = false;
                });

        },

        /*
         * Sets the default player weightings for the player weighting sliders.
         *
         * This is triggered when a season initially is set or changes.
         */
        setPlayerWeightings: function() {
            if( ! ( this.player && this.player.id ) || ! this.$store.inputs.current.seasonId ) {
                return;
            }

            this.$store.weightingsLoading = true;
            axios.get('api/player-weightings/' + this.player.id + '/' + this.$store.inputs.current.seasonId)
                .then( response => {

                    // save these values
                    this.initialWeightings = Object.create( response.data );

                    // update the sliders
                    sliders.set('passing', response.data.passing);
                    sliders.set('creating', response.data.creating);
                    sliders.set('shooting', response.data.shooting);
                    sliders.set('defensive', response.data.defensive);
                    this.$store.weightingsLoading = false;
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
        },

        /*
         * Removes the active player and starts the process again.
         *
         * This is triggered by the close button on a player's card.
         */
        removePlayer: function() {
            // Clear the player's details
            this.player = Object.create( BLANK_PLAYER );

            // Hide the player matches popout
            this.closePlayerMatches();
        },

        /*
         * Once a player has been selected, along with a season, primary skill and primary style
         * (along with an optional league), load a list of matching players into a popout.
         *
         * This is triggered by the Find Players button.
         */
        loadPlayerMatches: function() {
            // Sanity check, ensure all three filters are always set
            if( ! this.$store.inputs.current.seasonId || ! this.$store.inputs.current.skillId || ! this.$store.inputs.current.styleId ) {
                return;
            }

            // Ensure the league selector popout is hidden
            this.$component('selectLeagueId').expanded = false;

            // Show the loading noticec
            this.$store.loading = true;

            // reset the anonymous revealed state
            if( pro() || elite() ) {
                this.playerMatches.revealed = false;
            }

            // Load player matches, passing the player ID and global filters
            let params = {
                season_id: this.$store.inputs.current.seasonId,
                skill_id: this.$store.inputs.current.skillId,
                style_id: this.$store.inputs.current.styleId,
                league_id: this.$store.inputs.current.leagueIds.join(','),
            };
            if( pro() || elite() ) {
                params = {
                    ...params,
                    passing: this.$store.inputs.current.passing,
                    creating: this.$store.inputs.current.creating,
                    shooting: this.$store.inputs.current.shooting,
                    defensive: this.$store.inputs.current.defensive,
                    passing_old: this.initialWeightings.passing,
                    creating_old: this.initialWeightings.creating,
                    shooting_old: this.initialWeightings.shooting,
                    defensive_old: this.initialWeightings.defensive,
                    gbe_eligible: this.$store.inputs.current.gbeEligible,
                    gbe_potential: this.$store.inputs.current.gbePotential,
                    gbe_ineligible: this.$store.inputs.current.gbeIneligible,
                    nation_id: this.$store.inputs.current.nationId,
                    age_min: this.$store.inputs.current.age.min,
                    age_max: this.$store.inputs.current.age.max,
                    height_min: this.$store.inputs.current.height.min,
                    height_max: this.$store.inputs.current.height.max,
                    minutes_played_min: this.$store.inputs.current.minutesPlayed.min,
                    minutes_played_max: this.$store.inputs.current.minutesPlayed.max,
                    value_min: this.$store.inputs.current.value.min,
                    value_max: this.$store.inputs.current.value.max,
                    contract_length_min: this.$store.inputs.current.contractLength.min,
                    contract_length_max: this.$store.inputs.current.contractLength.max,
                    international_apps: this.$store.inputs.current.internationalApps,
                };
            }
            axios.get('/api/find-players/' + this.player.id, { params })
                .then( response => {

                    // Hide the loading notices
                    this.$store.loading = false;
                    $c('appMain').loading = false;

                    // Reset the Reveal status for anon mode
                    this.playerMatches.revealed = false;

                    // reset the activeMenus state
                    this.playerMatches.activeMenus = [];

                    // if no results then show an error and return
                    if( response.data.length === 0 ) {
                        modal(getLang('find_players_no_results'));
                        return;
                    } else {

                        // Save the results
                        this.playerMatches.results = Object.create( response.data );

                        // Show the results popout
                        this.openPlayerMatches();

                        // Scroll to results (needed for mobile view where these are below the main panel)
                        // and reset scroll position for the list of results
                        this.$nextTick( () => {
                            document.querySelector('#results').scrollIntoView({ behavior: 'smooth', block: 'start' });
                            document.querySelector('#results').scrollTop = 0;
                        });

                        // track global filters and hide popout if anything changes
                        if( ! this.filterWatchersSet ) {
                            this.filterWatchersSet = true;
                            Spruce.watch('inputs.current', () => this.closePlayerMatches());
                        }

                        // Add this state to history
                        let parts = [
                            'results',
                            stringToSlug( this.player.name ),
                            this.player.id,
                            this.$store.inputs.current.seasonId,
                            this.$store.inputs.current.skillId,
                            this.$store.inputs.current.styleId,
                            this.$store.inputs.current.leagueIds.join(','),
                        ];
                        if( pro() || elite() ) {
                            parts = [
                                ...parts,
                            this.$store.inputs.current.passing,
                            this.$store.inputs.current.creating,
                            this.$store.inputs.current.shooting,
                            this.$store.inputs.current.defensive,
                            this.initialWeightings.passing,
                            this.initialWeightings.creating,
                            this.initialWeightings.shooting,
                            this.initialWeightings.defensive,
                            this.$store.inputs.current.gbeEligible,
                            this.$store.inputs.current.gbePotential,
                            this.$store.inputs.current.gbeIneligible,
                            this.$store.inputs.current.nationId,
                            this.$store.inputs.current.age.min,
                            this.$store.inputs.current.age.max,
                            this.$store.inputs.current.height.min,
                            this.$store.inputs.current.height.max,
                            this.$store.inputs.current.minutesPlayed.min,
                            this.$store.inputs.current.minutesPlayed.max,
                            this.$store.inputs.current.value.min,
                            this.$store.inputs.current.value.max,
                            this.$store.inputs.current.contractLength.min,
                            this.$store.inputs.current.contractLength.max,
                            this.$store.inputs.current.internationalApps,
                            ];
                        }

                        let path = buildPath(parts);

                        // only push to history if this is different, else replace
                        if( path != this.$store.history.url ) {
                            historyManager.push(path, {});
                        } else {
                            historyManager.replace(path, {});
                        }

                    }

                    // update the searches
                    if( standard() ) {
                        this.updateRemainingSearches();
                    }

                })
                .catch( response => {
                    modal(getLang('generic_error'));

                    // Hide the loading notice
                    this.$store.loading = false;
                })
        },

        /*
         * Opens the player matches popout.
         *
         */
        openPlayerMatches: function() {
            //close the results popout
            this.playerMatches.active = true;
        },

        /*
         * Close the player matches popout.
         *
         * This is triggered by watchers for any changes on the global filters, and the
         * removePlayer function.
         */
        closePlayerMatches: function(fromRouter) {
            //close the results popout
            this.playerMatches.active = false;

            //reset the history state
            if( ! fromRouter ) {
                historyManager.reset();
            }
        },

        /*
         * This getter sorts the list of player matches depending on the sortBy speficied.
         *
         * It is used by the loop on the player matches popout
         */
        get playerMatchResultsSorted() {
            // Sort the results via the sortBy variable, either percentageMatch, position or season
            let r = this.playerMatches.results;
            if( this.$store.sortBy == 'percentageMatch' ) {
                r.sort( (a, b) =>
                    +a.percentageMatch === +b.percentageMatch
                        ? 0
                        : (+a.percentageMatch > +b.percentageMatch) ? -1 : 1
                );
            } else if( this.$store.sortBy == 'position' ) {
                const sortPlayerName = (a, b) => a.name === b.name ? 0 : (a.name  > b.name ) ? 1 : -1;
                let samePos = r.filter( p => p.position == this.player.position );
                let otherPos = r.filter( p => p.position != this.player.position );
                samePos.sort(sortPlayerName);
                otherPos.sort(sortPlayerName);
                r = [...samePos, ...otherPos];
            } else if( this.$store.sortBy == 'season' ) {
                r.sort( (a, b) =>
                    a.season.name === b.season.name
                        ? 0
                        : (a.season.name  > b.season.name ) ? -1 : 1
                );
            } else if( this.$store.sortBy == 'minutes' ) {
                r.sort( (a, b) =>
                    +a.minutes === +b.minutes
                        ? 0
                        : (+a.minutes  > +b.minutes ) ? -1 : 1
                );
            } else if( this.$store.sortBy == 'percentAvailable' ) {
                r.sort( (a, b) =>
                    +a.availablePercentage === +b.availablePercentage
                        ? 0
                        : (+a.availablePercentage  > +b.availablePercentage ) ? -1 : 1
                );
            }
            return r;
        },

        /*
         * Utility function to get an identifier for an anonymous player
         */
        getAnonName: function(index) {
            const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
            if( index < 26 ) {
                return letters[index];
            } else {
                return letters[Math.ceil(index / 25) - 2] + this.getAnonName( index % 26 );
            }
        },

        /*
         * Utility function to see if a player is a goalkeeper
         */
        isGoalkeeper: function() {
            if( ! this.player || ! this.player.position ) {
                return false;
            }
            return this.player.position === 'GK';
        }
    }
};
